/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 */

import './Provider/TranslationProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'regenerator-runtime/runtime.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './Services/Api/QueryClient';
import 'dayjs/locale/de';
import { SitePackageProvider } from './Provider/SitePackageProvider';
import { jumpersThemeConfig } from './Config/JumpersThemeConfig';
import { aiFitnessThemeConfig } from './Config/AiFitnessThemeConfig';
import { StudioLocatorMap } from './StudioLocator/StudioLocatorMap';

const magiclineStudioLocator = document.querySelectorAll('[data-magicline-studiolocator]');
const { sitePackage } = JSON.parse(magiclineStudioLocator[0].getAttribute('data-magicline-studiolocator'));
const themeConfig = (sitePackage === 'Jumpers.JumpersFitnessTld') ? jumpersThemeConfig : aiFitnessThemeConfig;
const themeClass = (sitePackage === 'Jumpers.JumpersFitnessTld') ? 'jumpers' : 'aifitness';
const theme = createTheme({ ...themeConfig });

magiclineStudioLocator.forEach((studioLocatorDOMObject) => {
  const root = ReactDOM.createRoot(studioLocatorDOMObject); // Erstellen einer neuen Root
  root.render(
    <SitePackageProvider
      values={JSON.parse(studioLocatorDOMObject.getAttribute('data-magicline-studiolocator'))}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <StudioLocatorMap themeClass={themeClass} />
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SitePackageProvider>,
  );
});
